import { __assign, __rest } from "tslib";
import React from 'react';
import { conditionalClassList } from '@at/formatter-utils/lib/class-name-utils/class-name.util';
import { BadgeCategories } from './badge.types';
import { StyledBadge } from './badge.styled';
export var Badge = function (_a) {
    var text = _a.text, hiddenText = _a.hiddenText, _b = _a.category, category = _b === void 0 ? BadgeCategories.default : _b, additionalClass = _a.additionalClass, _c = _a.className, className = _c === void 0 ? '' : _c, otherHTMLProperties = __rest(_a, ["text", "hiddenText", "category", "additionalClass", "className"]);
    var classList = conditionalClassList(!!additionalClass && "".concat(additionalClass), !!className && className);
    return (React.createElement(StyledBadge, __assign({ className: classList, category: category }, otherHTMLProperties),
        text,
        hiddenText && React.createElement("span", { className: "visuallyhidden" }, hiddenText)));
};
